"use client";

import Link from "next/link";

export interface BreadcrumbsProps {
  is404?: boolean;
  children?: React.ReactNode;
}

export interface BreadcrumbProps {
  breadcrumb: {
    name: string;
    url: string;
    section?: string;
  };
  current?: boolean | "false" | "true" | "page" | "step" | "location" | "date" | "time";
  slug?: string | undefined;
}

/**
 * A wrapper around the AfaBreadcrumbs component to be used in client components.
 * @param props - Props to be passed to the AfaBreadcrumbs component.
 * @returns The AfaBreadcrumbs component with the passed props.
 */
const BreadcrumbsWrapper = (props: BreadcrumbsProps) => {
  if (props.is404) {
    return null;
  }
  return props.children;
};

export function Breadcrumb({ breadcrumb, current, slug }: BreadcrumbProps) {
  if (current === "page") {
    return (
      <span aria-current="page" data-testid={`breadcrumb-link-${slug}`}>
        {breadcrumb?.name}
      </span>
    );
  }

  return (
    <Link
      href={breadcrumb?.url}
      prefetch={false}
      // onClick={() => breadcumbsLinksTracker(breadcrumb.name, breadcrumb.section)}
      aria-current={current}
      data-testid={`breadcrumb-link-${slug}`}
    >
      {breadcrumb?.name}
    </Link>
  );
}

export default BreadcrumbsWrapper;
